import React, { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Login from '../Login/LoginPage'
import Register from '../Register/RegisterPage'
import UserProfilePage from '../UserProfile/UserProfilePage'
import GameLibraryPage from '../Library/GameLibraryPage'
import HomePage from '../Home/HomePage'
import GamesPage from '../Games/GamesPage'
import GameDetailsPage from '../Games/GameDetailsPage'
import SupportPage from '../../pages/Support/SupportPage'

const TopLevelRoutes = (): React.JSX.Element => {
  const location = useLocation()

  useEffect(() => {
    const isGamesPage =
      location.pathname.toLowerCase() === '/games'

    const isGameDetailsPage =
      /^\/games\/\d+$/i.test(location.pathname)

    if (!isGamesPage && !isGameDetailsPage) {
      sessionStorage.removeItem('gameSearchQuery')
      sessionStorage.removeItem('gameSearchResults')
      sessionStorage.removeItem('gameScrollPosition')
    }
  }, [location.pathname])

  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/Register" element={<Register />} />
      <Route path="/Login" element={<Login />} />
      <Route path="/UserProfile" element={<UserProfilePage />} />
      <Route path="/profile" element={<UserProfilePage />} />
      <Route path="/Library" element={<GameLibraryPage />} />
      <Route path="/Games" element={<GamesPage />} />
      <Route path="/Support" element={<SupportPage />} />
      <Route
        path="/games/:id"
        element={<GameDetailsPage />}
      />
      <Route path="*" element={<Login />} />
    </Routes>
  )
}

export default TopLevelRoutes